module.exports = __webpack_public_path__ + "static/img/2.4681f49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/2.png
// module id = LAUg
// module chunks = 0